import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import {
  activeFilter,
  DynamoDbOperations,
  DynamoDbTables,
  Source,
} from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";


export type Site = {
  siteName: string;
  siteId: string;
  timeZone: string;
}

export const sitesQuery: Source<Site[]> = {
  graphql: parse(`
    query listSites($nextToken: String) {
      listSites(
        limit: 10000,
        filter: { isActive: { eq: true } }
        nextToken: $nextToken
      ) {
        nextToken
        items {
          siteName
          siteId
          timeZone
        }
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.QUERY,
    table: DynamoDbTables.SITES,
    // The table holds several models under one partition key; "SiteTable" is the one the
    // sites live under, and is what Query.listSites.req.vtl defaults modelName to.
    keyCondition: () => ({
      expression: "#modelName = :modelName",
      names: { "#modelName": "modelName" },
      values: { ":modelName": "SiteTable" },
    }),
    filter: activeFilter,
  },
};

export const getSites = async (client: SchemaClient): Promise<Site[] | typeof EMPTY_VALUE> => {
  return await client.queryList(sitesQuery);
};

export const getAndProcessSites = async (client: SchemaClient): Promise<Site[]> => {
  const sites = await getSites(client);
  return sites?.map((site: Site) => ({
    siteName: site.siteName,
    siteId: site.siteId,
    timeZone: site.timeZone,
  })) ?? [];
};